import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import {
  createStatus,
  getStatus,
  getStatuses,
  editStatus,
  deleteStatus,
} from "api/statusApi"

export const STATUS_QUERY_KEY = "statuses"

export const useStatuses = (params = {}, enabled = true) => {
  return useQuery({
    queryKey: [STATUS_QUERY_KEY, params],
    queryFn: () => getStatuses(params),
    keepPreviousData: true,
    enabled
  })
}

export const useStatus = id => {
  return useQuery({
    queryKey: [STATUS_QUERY_KEY, id],
    queryFn: () => getStatus(id),
    enabled: !!id,
  })
}

export const useCreateStatus = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createStatus,
    onSuccess: data => {
      if (data?.success) {
        queryClient.invalidateQueries([STATUS_QUERY_KEY])
      }
    },
  })
}

export const useEditStatus = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: editStatus,
    onSuccess: data => {
      if (data?.success) {
        queryClient.invalidateQueries([STATUS_QUERY_KEY])
      }
    },
  })
}

export const useDeleteStatus = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteStatus,
    onSuccess: data => {
      if (data?.success) {
        queryClient.invalidateQueries([STATUS_QUERY_KEY])
      }
    },
  })
}
